export enum TransactedTypeEnum {
  cashAdvance = 'cashAdvance',
  buyerRebate = 'buyerRebate',
  discount = 'discount',
  powerDiscount = 'powerDiscount',
  incentive = 'incentive',
}
